var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"text-color-primary",attrs:{"href":"#"},on:{"click":() => {
      _vm.$router.back();
    }}},[_c('i',{staticClass:"el-icon-back font-black i-arrow-left-back"})])
}
var staticRenderFns = []

export { render, staticRenderFns }